<template>
  <div class="app">
    <AppHeader fixed>
      <div class="vld-parent">
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="fullPage"
        ></loading>
      </div>
      <b-modal
        title="Select Warehouse"
        size="sm"
        v-model="showWarehouse"
        @ok="updateSite"
      >
        <select v-model="selectedWarehouse" class="form-control">
          <option
            v-for="option in options"
            :value="option"
            v-bind:selected="option == selectedWarehouse.serverwarehouseId"
            v-bind:key="option.SiteCode"
          >
            {{ option.SiteDescription }}
          </option>
        </select>
      </b-modal>
      <SidebarToggler class="d-lg-none" display="md" mobile />

      <b-link class="navbar-brand" to="#">
        <img
          class="navbar-brand-full"
          src="img/brand/logo.png"
          width="89"
          height="25"
          alt="itsek Logo"
        />
        <img
          class="navbar-brand-minimized"
          src="img/brand/logo.png"
          width="30"
          height="30"
          alt="itsek Logo"
        />
      </b-link>

      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="ml-auto">
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="navItems"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <div id="department" class="mb-1 subtitle-row">
          <span class="subtitle-text font-weight-bold text-center">{{
            this.branchtitle
          }}</span>
        </div>
        <div class="dispatch-table">
          <Breadcrumb id="breadview" :list="list" />
        </div>

        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <TheFooter>www.fastlogistics.com.ph</TheFooter>
  </div>
</template>

<script>
import nav from "@/_nav";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb,
} from "@coreui/vue";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdown from "./DefaultHeaderDropdown";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { all } from "q";
import miniToastr from "mini-toastr";
import api from "./../services/api";

export default {
  name: "DefaultContainer",
  components: {
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdown,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    Loading,
  },

  data() {
    return {
      branchtitle: this.$store.getters.warehousedesc,
      navItems: this.$store.getters.nav,
      fullPage: true,
      options: this.$store.getters.branches,
      tempWarehouse: 0,
      tempWarehouseCode: 0,
    };
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        (route) => route.name || route.meta.label
      );
    },
    isLoading: {
      get: function () {
        return this.$store.getters.isLoading;
      },
      set: function (value) {
        this.$store.commit("isLoading", value);
      },
    },
    showWarehouse: {
      get: function () {
        return this.$store.getters.isWarehouse;
      },
      set: function (value) {
        this.$store.commit("warehouse", value);
      },
    },
    selectedWarehouse: {
      get: function () {
        return this.$store.getters.selectedWarehouse;
      },
      set: function (value) {
        this.tempWarehouse = value;
        this.tempWarehouseCode = value;
      },
    },
  },
  methods: {
    onGetMenu: function () {
      let self = this;
      var stores = this.$store.getters;

      api.instance
        .get("/account/get-app-menu-v2/?sysid=22&userid=" + stores.user.userId)
        .then((resp) => {
          let menuData = [];
          console.log("raw menu:", resp);
          menuData.push({
            name: "Dashboard",
            url: "/dashboard",
            icon: "cui-bar-chart icons",
            badge: {
              variant: "primary",
            },
          });
          //check mother menu
          resp.data.forEach((element) => {
            if (element.stage === "637217940014876505") {
              var accessMenuData = [];
              let childMenu = [];
              //get child menu
              element.pages.forEach((child) => {
                childMenu.push({
                  name: child.name,
                  id: child.stage,
                  // icon: "icon-puzzle"
                });
              });

              accessMenuData.push({
                name: element.name,
                url: "/" + element.name,
                icon: "icon-puzzle",
                children: childMenu,
              });
              self.$store.state.access = childMenu;
            } else {
              if (element.stage === "636951518284808842") {
                element.pages.forEach((child) => {
                  menuData.push({
                    name: child.name,
                    url: "/" + child.stage,
                    icon: "icon-puzzle",
                  });
                });
              } else {
                let childMenu = [];
                //get child menu
                element.pages.forEach((child) => {
                  childMenu.push({
                    name: child.name,
                    url: "/" + element.name + "/" + child.stage,
                    // icon: "icon-puzzle"
                  });
                });

                menuData.push({
                  name: element.name,
                  url: "/" + element.name,
                  icon: "icon-puzzle",
                  children: childMenu,
                });
              }
            }
          });

          // //add static report

          // menuData[menuData.length - 1].children.push({
          //   name: "Graphs",
          //   url: "/Reports/201927046995420000",
          // });
          //console.log('menu',menuData);
          self.navItems = menuData;
          console.log("testing", menuData);
          this.$store.commit("setNav", menuData);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    updateSite: function () {
      let warehousedesc = "";
      this.options.forEach((element) => {
        if (element.SiteCode === this.tempWarehouse.SiteCode) {
          warehousedesc = element.SiteDescription;
        }
      });

      let warehouseJsonData = {
        warehousecode: this.tempWarehouse.SiteCode,
        warehousedesc: warehousedesc,
      };
      this.$store.commit("selectedWarehouse", this.tempWarehouse.SiteCode);
      this.$store.commit("warehousecode", warehouseJsonData);
      //this.initTable();
    //  this.initDashboard();
      // this.$store.commit("setLoading", true);
      this.showWarehouse = false;
            

      //       this.$store.commit("setLoading", false);
    },

      initDashboard: function () {
      // Here we don't set isBusy prop, so busy state will be handled by table itself
      this.isBusy = true;
      let self = this;
      self.$store.commit("setLoading", true);
      let promise = api.instance.get(
        "/itsek/get-itsek-dashboard?department=" +
          this.$store.getters.selectedWarehouse +
          "&emplID=" +
          this.$store.getters.user.emplId
      );

      return promise
      // axios.get("http://localhost:58426/api/itsek/get-itsek-dashboard?department=FSC01&emplID=18092475")
        .then((resp) => {
          self.$store.commit("setLoading", false);
          self.$store.state.dashboard = null;
          self.$store.state.dashboard = resp.data;
          // Here we could override the busy state, setting isBusy to false
          self.isBusy = false;

          //   return items;
        })
        .catch((error) => {
          // Here we could override the busy state, setting isBusy to false
          self.isBusy = false;
          self.$store.commit("setLoading", false);
          // Returning an empty array, allows table to correctly handle busy state in case
          // of error
          return [];
        });
    },
  },
  created: function () {
    this.onGetMenu();
  },

  watch: {
    selectedWarehouse() {
      this.branchtitle = this.$store.state.warehousedesc;
      window.location.reload();
      this.$store.dispatch("setLoader", true);
    },
  },
};
var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
        (function(){
        var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
        s1.async=true;
        s1.src='https://embed.tawk.to/6211d95b1ffac05b1d7ac12c/1fsari3nm';
        s1.charset='UTF-8';
        s1.setAttribute('crossorigin','*');
        s0.parentNode.insertBefore(s1,s0);
        })();
</script>
